import { MiniatureComponent } from './../miniature.component';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { VideoTimelineComponent } from '../../video-timeline/video-timeline.component';
import { mediaService, MediaTest } from '@services/media/media.service';
import { NotificationService } from '@services/notifications/notification.service';
import { UiService } from '@services/ui/ui.service';
import { VideoWasteComponent } from '../../video-waste/video-waste.component';
import { Media } from '@classes/media/media';
import * as moment from 'moment';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent implements OnInit, OnChanges {
  time: string;
  idUpdate: string;


  @Input() id: string;
  @Input() date: string;

  url: any;
  safeUrl: any;

  constructor(
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private mediaService: mediaService,
    private notificationService: NotificationService,
    private uiSrv: UiService,
    private miniatureComponent: MiniatureComponent
  ) { }

  ngOnInit(): void {
    this.getTime(this.id)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.id) {

      this.getImage(changes.id.currentValue)

    }

    if (changes.data) {
      this.getTime(changes.data.currentValue)

    }
  }

  getImage(id: string): any {


    this.url = `${environment.apiUrl}/medias/${id}/file`
    // fetch(`${environment.apiUrl}/medias/${id}/file`,
    //   {
    //     method: 'GET',
    //     headers: {
    //       authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}`,
    //       'content-type': 'application/media'
    //     }
    //   })
    //   .then(response => response.body)
    //   .then(rb => {
    //     const reader = rb.getReader();

    //     return new ReadableStream({
    //       start(controller) {
    //         return pump();
    //         function pump() {
    //           return reader.read().then(({ done, value }) => {
    //             if (done) {
    //               controller.close();
    //               return;
    //             }
    //             controller.enqueue(value);
    //             return pump();
    //           });
    //         }
    //       }
    //     })
    //   })
    //   .then(stream => new Response(stream))
    //   .then(response => response.blob())
    //   .then(blob => URL.createObjectURL(blob))
    //   .then(url => {

    //     this.url = url;
    //     this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);


    //   })
    //   .catch(err => console.error(err));

  }


  PostRequestVideo(id: string): any {
    let confirmation = confirm("Do you want to make a video request for this thumbnail?");
    if (confirmation) {
      this.uiSrv.showSnackbar('Your video request has been sent')
      this.mediaService.PostMedia(id).subscribe(res => {
        setTimeout(() => {
          this.miniatureComponent.GetMediaRequest();
        }, 15000)

      });
    }


  }
  openDialogInfoCamera(): void {

    const dialogRef = this.dialog.open(VideoWasteComponent, {
      data: { mediaId: this.idUpdate },
    });


  }

  private getTime(id: string): void {
    const dateSplit = this.date.replace(/\_/g, '-').replace(/\.jpg/g, '').split('-')
    let newDate = `${dateSplit[0]}/${dateSplit[1]}/${dateSplit[2]} ${dateSplit[3]}:${dateSplit[4]}`;
    let dateParseZone = moment(newDate).parseZone().utc().local().format('HH:mm');
    this.time = dateParseZone;

  }

}
